export * from './forgot-password/forgot-password.component';
export * from './login-fail/login-fail.component';
export * from './user-registration/user-registration.component';
